import $ from 'jquery';
import _ from 'lodash';
import { getState, getStatePure } from '~src/state';
import { isLoggedUserGlobalEditor } from '~src/user';
import { editorConfig } from '~config';
import { ensureAllPagesHavePreview } from '~core';
import { handleChangePageBtn } from '~src/multipages';
import { FEATURES, isFeatureEnabled } from '../features';

export const addPagesToSidebar = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const canUserAddPages = await isFeatureEnabled(FEATURES.ADD_PAGES);

  await ensureAllPagesHavePreview();

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  let pageIndex = 0;

  const html = pages.reduce((acc, page) => {
    const pagePreviewUrl = _.get(
      page,
      'preview.url',
      editorConfig.pagePreviewPlaceholder
    );
    const template = `
          <div class="editor-sidebar-item-container ${
            pageIndex === currentPageIndex ? 'editor-sidebar-page-current' : ''
          }" data-page-index="${pageIndex}" id="editor-page-${pageIndex}">
                  <div class="editor-sidebar-slides-pagination"><span>${
                    pageIndex + 1
                  }</span></div>
                  <div class="editor-sidebar-page-preview">
                      ${
                        page.imgData
                          ? `<img src="data:image/png;base64, ${page.imgData}" />`
                          : `<img src="${pagePreviewUrl}" />`
                      }
                  </div>
                  <div
                    id="editor-sidebar-sub-menu-${pageIndex}"
                    class="editor-sidebar-item-sub-menu-container  editor-sidebar-item-page">
                    <button
                      id="btn-page-delete-${pageIndex}"
                      class="btn btn-sidebar-pages-delete editor-pages-box-delete"
                      data-page-btn-index="${pageIndex}"
                      data-page-url="${pagePreviewUrl}"> ELIMINA
                    </button>
                  </div>
              </div>
              `;

    acc += template;
    pageIndex++;
    return acc;
  }, '');
  if (isGlobalEditor || canUserAddPages) {
    const htmlButton = `
        <div class="sidebar-box-btns-area d-flex">
          <button id="editor-menu-editable-page" class="buttonSidebarDouble btn-ofc-secondary-blue m-1">
            Modifica
          </button>
  
          <button id="editor-menu-add-page" class="buttonSidebarDouble btn-ofc-secondary-blue m-1">
            Aggiungi
          </button>
        </div>`;
    $('#btn-manage-pages').html(htmlButton);
  }

  $('#editor-sidebar-pages').html(html);

  $('body').off('click', '[data-page-index]');
  $('body').on('click', '[data-page-index]', handleChangePageBtn);
  // makePagesDraggable();
};
